const state = {
  configDomains: [],
  pageDomain: '',
  autoRefresh: true
}

const mutations = {
  SET_CONFIG_DOMAINS(state, val) {
    state.configDomains = val
  },
  SET_PAGE_DOMAIN(state, val) {
    state.pageDomain = val
  },
  SET_AUTO_REFRESH(state, val) {
    state.autoRefresh = val
  },
  RESET_STATE(state) {
    state.configDomains = []
  }
}

const actions = {
  setPageDomain({ commit }, val) {
    commit('SET_PAGE_DOMAIN', val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
